import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { DeliveryCompany } from "../../deliveryCompanies.types";
import { requestToggleDeliveryCompanyActive } from "./toggleDeliveryCompanyActive.request";

const useToggleDeliveryCompanyActive = (
  options?: MutationOptions<DeliveryCompany, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestToggleDeliveryCompanyActive,
    ...options
  });
};

export default useToggleDeliveryCompanyActive;
